import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import TopNavBarSpan from "./TopNavBarSpan";
import { showGrade } from "../utils/textUtils";
import { formatPoint, usePointBalance } from "../features/reward/pointStore";
import { BagIcon, CoinIcon } from "../features/reward/RewardIcons";
import "./TopNavBar.css";

// 학원 로고: 주소가 있을 때만 이미지를 보여준다.
// 학생 화면에는 기본 로고를 두지 않는다. 학원이 로고를 안 걸었으면 그 자리를 비운다.
// (교사 화면은 반대로 ECHO 기본 로고를 띄운다. 우리 서비스 안이라는 표시가 필요해서다.)
const AcademyLogo = ({ src }) => {
  const [failed, setFailed] = useState(false);

  // 로고 주소가 바뀌면(재로그인 등) 실패 상태 초기화
  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return null;
  }

  return (
    <img
      src={src}
      alt="학원 로고"
      onError={() => setFailed(true)}
      className="student-nav__logo"
    />
  );
};

// 상단 바 한 줄에 [학원 로고] [메뉴] [학생 이름] 을 모두 둔다. teacher 상단 바와 같은 배치다.
const TopNavBar = ({ topTab, selectTab, tabList }) => {
  const { student } = useSelector((state) => state.student);
  const navigate = useNavigate();
  const location = useLocation();
  // 오른쪽 위 포인트 · 상점(2026-10-04). 누르면 상점으로 간다. 세션은 주소에 그대로 들고 간다.
  const { balance, isOpen: isStoreOpen } = usePointBalance(Boolean(student?.id));

  let gradeText = "";
  try {
    if (student?.grade !== undefined && student?.grade !== null) {
      gradeText = showGrade(student.grade);
    }
  } catch (e) {
    gradeText = "";
  }

  // 폰에서는 메뉴 줄이 옆으로 넘친다(수학 학생은 '오답노트' 까지 넷). 고른 메뉴가 화면 밖에 숨지 않게 끌어온다
  const tabsRef = useRef(null);
  useEffect(() => {
    const active = tabsRef.current?.querySelector(".student-nav__tab--active");
    if (active && active.scrollIntoView) active.scrollIntoView({ block: "nearest", inline: "nearest" });
  }, [topTab, tabList.length]);

  return (
    <div className="student-nav">
      <div className="student-nav__inner">
        <div className="student-nav__side">
          <AcademyLogo src={student?.logo_img} />
        </div>

        <div className="student-nav__tabs" ref={tabsRef}>
          {tabList.map((tab) => (
            <TopNavBarSpan
              key={tab.name}
              topTab={topTab}
              selectTab={selectTab}
              tabName={tab.name}
              tabText={tab.text}
            />
          ))}
        </div>

        <div className="student-nav__side student-nav__side--right">
          <b className="student-nav__student-name">{student?.name || ""}</b>
          {gradeText && <span className="student-nav__student-grade">{gradeText}</span>}
          {isStoreOpen && (
            <button
              type="button"
              className={`student-nav__store${topTab === "store" ? " student-nav__store--active" : ""}`}
              onClick={() => navigate(`/store${location.search}`)}
            >
              <span className="student-nav__points">
                <CoinIcon />
                {balance === null ? "…" : formatPoint(balance)}
              </span>
              <span className="student-nav__store-label">
                <BagIcon size="1em" />
                스토어
              </span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default TopNavBar;
